<template>
    <m-input :active="focus" @click="setFocus()" :helper="helperText" :error="error">
        <textarea class="h-32 border outline-none p-2 w-full border-gray-400 rounded-md shadow-md" v-model="model" @focus="updateFocus(true)"
                  @blur="updateFocus(false)" ref="input" @input="handleInput()" @keydown.enter="$emit('enter')"
                  :maxlength="maxlength"></textarea>
    </m-input>
</template>
<script>

export default {
    props: {
        value: String,
        error: {
            type: Boolean,
            default: false
        },
        maxlength: {
            type: Number,
            default: 524288 // default value form w3schools
        },
        helperText: String
    },
    watch: {
        // detect external change
        value(newval) {
            this.model = newval
        }
    },
    data() {
        return {
            model: this.value,
            focus: false
        };
    },
    methods: {
        handleInput() {
            this.$emit('input', this.model)
        },
        updateFocus(state) {
            this.focus = state
            this.$emit('focus', state)
        },
        setFocus() {
            this.$refs.input.focus();
        }
    }
};
</script>